<template>
  <div class="recharge-container">
    <van-nav-bar fixed :title="$t('recharge')" left-text="返回" left-arrow>
      <template #left>
        <img @click="navBack" class="back" src="../../assets/back.svg" alt="" />
      </template>
      <template #right>
        <img
          @click="goRecord"
          class="record"
          src="../../assets/recharge-record.svg"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="content">
      <div class="content-top">
        <div class="content-top-left">{{ $t("recharge_currency") }}</div>
        <div class="content-top-right" @click="show = true">
          <img
            v-if="currentType.name && currentType.name.startsWith('USDT')"
            src="../../assets/USDT.png"
            class="logo"
            alt=""
          />
          <img
            v-if="currentType.name == 'BTC'"
            src="../../assets/BTC.png"
            class="logo"
            alt=""
          />
          <img
            v-if="currentType.name == 'ETH'"
            src="../../assets/ETH.png"
            class="logo"
            alt=""
          />
          {{ currentType.name }}
          <img src="../../assets/picker-arrow.svg" class="arrow" alt="" />
        </div>
      </div>
      <div class="content-mid">
        <div class="content-mid-code">
          <div class="code-box">
            <div class="qrcode" ref="qrCodeUrl"></div>
          </div>
          <div class="code-tip">{{ $t("recharge_scan code transfer") }}</div>
        </div>
      </div>
      <div class="content-bot" v-clipboard:copy="currentType.address" v-clipboard:success="onCopy">
        <div class="content-bot-left">
          {{ currentType.address }}
        </div>
        <div class="content-bot-right">
          <img src="../../assets/recharge-copy.svg" alt="" />
        </div>
      </div>
    </div>
    <div class="input-box">
      <div class="input-row">
        <div class="input-row-title">{{ $t("recharge_amount") }}</div>
        <div class="input-row-content">
          <input
            inputmode="decimal"
            type="number"
            v-model="money"
            :placeholder="$t('please enter')"
          />
        </div>
      </div>
      <div class="input-row">
        <div class="input-row-title">{{ $t("recharge_upload") }}</div>
        <div class="input-row-content">
          <van-uploader
            v-model="fileList"
            :max-count="1"
            :after-read="afterRead"
          />
        </div>
      </div>
      <div class="input-box-btn" @click="recharge">{{ $t("confirm") }}</div>
      <div class="recharge-channel-list">
        <div class="channel-item" @click="goCoin">
          <div class="channel-item-left">
            <img src="../../assets/coinbase.png" alt="" />
            {{ $t("rachange_link_coinbase") }}
          </div>
          <div class="channel-item-right">
            <img src="../../assets/arrow-right-black.svg" alt="" />
          </div>
        </div>
        <div class="channel-item" @click="goBin">
          <div class="channel-item-left">
            <img src="../../assets/binance.png" alt="" />
            {{ $t("rachange_link_binance") }}
          </div>
          <div class="channel-item-right">
            <img src="../../assets/arrow-right-black.svg" alt="" />
          </div>
        </div>
        <div class="channel-item" @click="goHuobi">
          <div class="channel-item-left">
            <img src="../../assets/huobi.png" alt="" />
            {{ $t("rachange_link_huobi") }}
          </div>
          <div class="channel-item-right">
            <img src="../../assets/arrow-right-black.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
    <van-action-sheet
      :cancel-text="$t('cancel')"
      close-on-click-action
      v-model="show"
      :actions="actions"
      @select="onSelect"
    />
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  data() {
    return {
      show: false,
      actions: [{ name: "选项一" }, { name: "选项二" }, { name: "选项三" }],
      currentType: {
        
      },
      money: "",
      formData: new FormData(),
      fileList: [],
      image: "",
    };
  },
  async created() {
    
    await this.getRechargeConfig();
  },
  methods: {
    onCopy() {
      this.$Toast(this.$t("copySuccess"));
    },
    createQrCode() {
      var qrcode = new QRCode(this.$refs.qrCodeUrl, {
        text: this.currentType.address,
        width: 175,
        height: 175,
        colorDark: "#000000",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    async recharge() {
      this.$Toast.loading({ forbidClick: true, duration: 0 });
      if (!this.money) {
        this.$Toast(this.$t("recharge_enter amount"));
        return;
      }
      if (this.money <= 0) {
        this.$Toast(this.$t("recharge_less zero"));
        return;
      }
      if (!this.image) {
        this.$Toast(this.$t("recharge_upload screenshot"));
        return;
      }
      let data = {
        money: this.money,
        config_id: 1,
        image: this.formData,
      };
      let formData = new FormData();
      formData.append("image", this.image.file);
      formData.append("money", this.money ? this.money : 0);
      formData.append("config_id", this.currentType.id);
      const res = await this.$api.recharge(formData);
      this.$Toast.clear()
      if (res.code == 200) {
        this.$Toast(this.$t("submit_success"));
        setTimeout(() => {
          this.$router.push('/recharge-record')
        }, 1000);
      } else {
        this.$Toast(res.message);
      }
    },
    async getRechargeConfig() {
      const res = await this.$api.getRechargeConfig();
      if (res.code == 200) {
        this.actions = res.data.map((item) => {
          return {
            id: item.id,
            currency: item.currency,
            name: item.type,
            address: item.address,
            max_money: item.max_money,
            min_money: item.min_money,
          };
        });
        this.currentType = this.actions[0];
        this.createQrCode();
      }
    },
    onSelect(e) {
      this.$refs.qrCodeUrl.innerHTML = "";
      this.currentType = e;
      this.createQrCode();
    },
    afterRead(file) {
      let formData = new FormData();
      this.image = file;
      console.log(file);
      formData.append(["file" + "[" + [0] + "]"], file.file);
      this.formData = formData;
    },
    goRecord() {
      this.$router.push("/recharge-record");
    },
    navBack() {
      this.$router.replace('/user');
    },
    goCoin() {
      window.open("https://www.coinbase.com/", "_blank");
    },
    goBin() {
      window.open("https://www.binance.com/", "_blank");
    },
    goHuobi() {
      window.open("https://www.huobi.com/", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.recharge-container {
  padding-top: 46px;
  .back {
    width: 30px;
    height: 15px;
  }
  .record {
    width: 40px;
    height: 60px;
  }
  .content {
    background: #fff;
    margin-top: 10px;
    padding: 15px 10px;
    &-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
      &-right {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: bold;
        .logo {
          width: 20px;
          height: 20px;
          margin-right: 10px;
        }
        .arrow {
          width: 15px;
          height: 10px;
          margin-left: 5px;
          margin-top: 5px;
        }
      }
    }
    &-mid {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 45px;
      &-code {
        .code-box {
          padding: 8px;
          border: 1px solid #0062f8;
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 174px;
            height: 174px;
          }
        }
        .code-tip {
          margin-top: 10px;
          color: #7d919d;
          font-size: 16px;
          text-align: center;
        }
      }
    }
    &-bot {
      padding: 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      background: #f7f7f8;
      border-radius: 5px;
      margin-top: 20px;
      &-left {
        flex: 1;
        word-break: break-all;
        line-height: 1.5;
        text-decoration: underline;
        font-size: 14px;
        margin-right: 20px;
      }
      &-right {
        img {
          width: 20px;
          height: 35px;
        }
      }
    }
  }
  .input-box {
    background: #fff;
    margin-top: 10px;
    padding: 10px 15px;
    padding-bottom: 45px;
    .input-row {
      margin-bottom: 20px;
      &-content {
        margin-top: 10px;
        input {
          width: 100%;
          background: #f2f4f7;
          border: none;
          color: #323233;
          box-sizing: border-box;
          padding: 15px 10px;
          font-size: 14px;
          border-radius: 3px;
        }
      }
    }
    &-btn {
      width: 100%;
      color: #fff;
      background: #0062f8;
      padding: 10px 0;
      text-align: center;
      font-size: 16px;
      border-radius: 3px;
    }
    .recharge-channel-list {
      margin-top: 30px;
      .channel-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 0;
        border-bottom: 1px solid #eee;
        &-left {
          display: flex;
          align-items: center;
          font-size: 14px;
          img {
            width: 25px;
            height: 25px;
            margin-right: 10px;
          }
        }
        &-right {
          display: flex;
          align-items: center;
          justify-content: center;
          img {
            width: 20px;
            height: 30px;
          }
        }
      }
    }
  }
}
@media (min-width: 640px) {
  /deep/ .van-nav-bar--fixed {
    width: 540px;
    left: unset;
  }
  /deep/ .van-popup--bottom {
    width: 540px;
    left: unset;
  }
  /deep/ .van-nav-bar__content {
    height: auto;
  }
  .recharge-container {
    padding-top: 46px;
    .back {
      width: 30px;
      height: 15px;
    }
    .record {
      width: 40px;
      height: 60px;
    }
    .content {
      background: #fff;
      margin-top: 10px;
      padding: 15px 10px;
      &-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        &-right {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: bold;
          .logo {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
          .arrow {
            width: 15px;
            height: 10px;
            margin-left: 5px;
            margin-top: 5px;
          }
        }
      }
      &-mid {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 45px;
        &-code {
          .code-box {
            padding: 8px;
            border: 1px solid #0062f8;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 174px;
              height: 174px;
            }
          }
          .code-tip {
            margin-top: 10px;
            color: #7d919d;
            font-size: 16px;
            text-align: center;
          }
        }
      }
      &-bot {
        padding: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        background: #f7f7f8;
        border-radius: 5px;
        margin-top: 20px;
        &-left {
          flex: 1;
          word-break: break-all;
          line-height: 1.5;
          text-decoration: underline;
          font-size: 14px;
          margin-right: 20px;
        }
        &-right {
          img {
            width: 20px;
            height: 35px;
          }
        }
      }
    }
    .input-box {
      background: #fff;
      margin-top: 10px;
      padding: 10px 15px;
      padding-bottom: 45px;
      .input-row {
        margin-bottom: 20px;
        &-content {
          margin-top: 10px;
          input {
            width: 100%;
            background: #f2f4f7;
            border: none;
            color: #323233;
            box-sizing: border-box;
            padding: 15px 10px;
            font-size: 14px;
            border-radius: 3px;
          }
        }
      }
      &-btn {
        width: 100%;
        color: #fff;
        background: #0062f8;
        padding: 10px 0;
        text-align: center;
        font-size: 16px;
        border-radius: 3px;
      }
      .recharge-channel-list {
        margin-top: 30px;
        .channel-item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid #eee;
          &-left {
            display: flex;
            align-items: center;
            font-size: 14px;
            img {
              width: 25px;
              height: 25px;
              margin-right: 10px;
            }
          }
          &-right {
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 20px;
              height: 30px;
            }
          }
        }
      }
    }
  }
}
</style>